{
  "version": 2,
  "as_of": "2026-06-05",
  "source": "GTA smart-grid PDD illustrative live-sim catalog. Anchors are selectable Scenario instances for free UI exploration; presets are story command-bundles. All ids grounded in data/reduced/{generators,nodes,edges}.json. NOTE: the 5 Debug-3 golden anchors used to reproduce simulation_results.json are NOT here — they remain the source of truth in environment(04)/golden, so golden validation never depends on this presentation asset. v2 (2026-06-05): headless validation through engine.v1 corrected the nuclear preset to model a plant trip as toggleNode(off) (injectFault{bus} leaves the generator seeded-live, so it did not drop the unit); added the feeder-fault-selfheal FLISR preset; and corrected the cyberattack note (comms recovery is operator-driven via clearFault, not automatic).",
  "anchors": [
    {
      "id": "spring-overnight-low",
      "label": "Spring overnight — ULO, low demand",
      "hour": 3,
      "season": "spring",
      "dayType": "weekday",
      "tempC": 8
    },
    {
      "id": "summer-midday-solar",
      "label": "Summer midday — solar peak, prosumer production",
      "hour": 13,
      "season": "summer",
      "dayType": "weekday",
      "tempC": 28
    },
    {
      "id": "summer-heatwave-peak",
      "label": "Summer heatwave — AC peak, thermal stress",
      "hour": 17,
      "season": "summer",
      "dayType": "weekday",
      "tempC": 35
    },
    {
      "id": "autumn-evening-peak",
      "label": "Autumn evening peak — moderate demand",
      "hour": 19,
      "season": "fall",
      "dayType": "weekday",
      "tempC": 10
    },
    {
      "id": "winter-evening-peak",
      "label": "Winter evening peak — highest demand",
      "hour": 18,
      "season": "winter",
      "dayType": "weekday",
      "tempC": -12
    }
  ],
  "presets": [
    {
      "id": "nuclear-plant-failure",
      "label": "Nuclear plant failure (Darlington trip)",
      "description": "At winter evening peak the Darlington NGS unit trips offline, removing ~3512 MW of must-run nuclear baseload (the system's largest single unit). Reserve headroom collapses toward zero; the engine ramps in-GTA gas back-fill and leans on the import interface — but imports are already near their cap at winter peak, so the remaining shortfall surfaces as totals.unservedMw and the affected parcels' walls shift toward 'stressed' then 'shed'. Recovery here is merit-order RE-DISPATCH, not tie reconfiguration — contrast feeder-fault-selfheal, where FLISR restores by closing a tie. Modelled as toggleNode(off) on the generator bus: that removes the unit from dispatch (a bus fault would merely open its incident edges while leaving the generator energized).",
      "commands": [
        { "t": "setScenario", "scenarioId": "winter-evening-peak" },
        { "t": "setClock", "hour": 18, "speed": 1 },
        { "t": "toggleNode", "id": "G_DARLINGTON_NGS_SITE", "on": false }
      ]
    },
    {
      "id": "summer-heatwave",
      "label": "Summer heatwave (no fault — thermal stress)",
      "description": "A 35 degC summer afternoon drives AC-dominated demand to a seasonal peak with no equipment fault. Lines load up: BranchFlow.loadingPct climbs into the heat band and the most-loaded corridors pulse 'stressed'. Demonstrates the pressure/crisis grammar driven purely by environment (diurnal x seasonal x temperature), and prosumer solar self-supply softening the peak. No injected fault, so nothing self-heals (no topology change, no B' rebuild) — this is the steady-stress baseline against which the fault presets are read.",
      "commands": [
        { "t": "setScenario", "scenarioId": "summer-heatwave-peak" },
        { "t": "setClock", "hour": 17, "speed": 1 }
      ]
    },
    {
      "id": "cyberattack",
      "label": "Cyberattack on comms (Claireville TS)",
      "description": "An autumn evening cyberattack jams the information layer at Claireville TS (W124486016, a real EHV hub). The information overlay around the target goes dark (radio arcs drop) while ENERGY KEEPS FLOWING — power physics are independent of comms, so dispatch and branch flows are byte-for-byte unchanged. This proves layer independence (R7): a comms fault is not a power outage. Recovery is operator-driven — issue clearFault on the comms target and the information arcs return on the next tick (the engine has no automatic comms self-heal; only energy FLISR is automatic).",
      "commands": [
        { "t": "setScenario", "scenarioId": "autumn-evening-peak" },
        { "t": "setClock", "hour": 19, "speed": 1 },
        { "t": "injectFault", "fault": { "targetKind": "comms", "targetId": "W124486016" } }
      ]
    },
    {
      "id": "feeder-fault-selfheal",
      "label": "Feeder fault + FLISR self-heal (neighbour-to-neighbour restore)",
      "description": "At winter evening peak the distribution feeder E_165 into DUR_PIC_P2 (a Pickering/Durham neighbourhood load) faults and is isolated. It is that load's head-end feed, so it is momentarily stranded. Auto-FLISR (no operator command) closes the normally-open NEIGHBOUR tie E_13276 to the adjacent neighbourhood TOR_TOR_144 (fed independently by E_58), re-energizing the stranded load FROM ITS NEIGHBOUR — the rebuild of B' is the topology-change tick. Contrast nuclear-plant-failure: there recovery is re-dispatch; HERE recovery is TIE RECONFIGURATION across the kept intra-GTA distribution network (V3 is the transmission backbone; the Debug-3 demand mesh + neighbour ties are RETAINED for exactly this self-heal). The injectFault{branch} command runs FLISR internally — the load is restored without an explicit self-heal step. (build log 86: demand network + neighbour-to-neighbour self-heal retained; V3 transmission bridged in, not replacing it.)",
      "commands": [
        { "t": "setScenario", "scenarioId": "winter-evening-peak" },
        { "t": "setClock", "hour": 18, "speed": 1 },
        { "t": "injectFault", "fault": { "targetKind": "branch", "targetId": "D3_E_165" } }
      ]
    }
  ]
}
